import { defaultLocale } from "react-day-picker";

import { useTranslations } from "@ui/providers/useTranslations";
import type { Locale } from "date-fns";

import type { Day } from "../../DatePicker.types";

export const useCustomLocale = (): Locale => {
  const { __ } = useTranslations();

  return {
    ...defaultLocale,
    localize: {
      ...defaultLocale.localize,
      day: (day: Day) => {
        /* 
          react-day-picker relies on date-fns
          date-fns was updated and now 0 is always Sunday
        */
        const replacedSundayOrDay = day === 0 ? 7 : day;
        const dayName = __("daypicker.day." + replacedSundayOrDay);
        return dayName;
      },
    },
  };
};
